import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ButtonContainer } from "../Shared/ButtonComponent";
import Successful from "../../Assets/Images/successful.png";

const TailoringOrders = ({
  tailoringOrders,
  setTailoringOrders,
  selectedOrder,
  orderArr,
  setOrderArr,
}) => {
  const closeModalHandler = () => setTailoringOrders(false);
  const [tailoringOrderSuccess, setTailoringOrderSuccess] = useState(false);
  const [completed] = useState(null);


  function updateStatus() {
    let updatedArray = orderArr.map((item) => {
      if (item.orderId === selectedOrder?.orderId) {
        return { ...item, status: "Delivered" };
      } else {
        return item;
      }
    });
    setOrderArr(updatedArray);
  }

  return (
    <div>
      <Modal
        dialogClassName={"OrdersModal"}
        show={tailoringOrders}
        onHide={closeModalHandler}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal-title"
          ></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h2 className="ord_details">Order Details</h2>
          </div>
          <div className="Laundry-Orders">
            <div className="laundry-order-page">
              <div>
                <img
                  alt="img"
                  src={
                    Array.isArray(selectedOrder?.tailoring_image_url)
                      ? selectedOrder?.tailoring_image_url[0]
                      : selectedOrder?.tailoring_image_url
                  }
                />
              </div>
              <div>
                <div>
                  <p className="text-capitalize">
                    {selectedOrder?.tailoring_name}
                  </p>
                  <p>
                    {selectedOrder?.date} {selectedOrder?.time}
                  </p>
                  <p>{selectedOrder?.orderId}</p>

                  <p className="fbc">+{selectedOrder?.whatsapp_number}</p>
                </div>
                <div>
                  {completed == null ? (
                    <p>{selectedOrder?.status}</p>
                  ) : (
                    <p>Delivered</p>
                  )}
                </div>
              </div>
            </div>
            <div className="laundry_content">
              <div>
                <p>Size</p>
                <p>{selectedOrder?.size}</p>
              </div>

              <div>
                <p>Pick Up</p>
                <p>{selectedOrder?.pick_up}</p>
              </div>
              <div>
                <p>Delivery</p>
                <p>
                  {selectedOrder?.delivery === "onsite"
                    ? "On site"
                    : selectedOrder?.delivery}
                </p>
              </div>
            </div>
            <div className="col-12 laundry_address">
              <div>
                <p>Delivery Address</p>
                <p>{selectedOrder?.delivery_address}</p>
              </div>
              {/* <div>
                <p>Fabric Pickup Address</p>
                <p>{selectedOrder?.pick_up}</p>
              </div> */}
            </div>
            <div className="col-12 laundrySummary-footer orderFooter">
              <div>
                <span>Subtotal:</span>
                <span>₦{selectedOrder?.tailoring_price}</span>
              </div>
              <div>
                <span>Delivery_fee:</span>
                <span>₦{selectedOrder?.delivery_fee}</span>
              </div>

              <div>
                <span>Total:</span>
                <span>
                  #
                  {selectedOrder?.delivery_fee + selectedOrder?.tailoring_price}
                </span>
              </div>
            </div>
          </div>

          {/* <ButtonContainer
            onClick={() => {
              setTailoringOrderSuccess(true);
              setTailoringOrders(false);
              updateStatus();
            }}
            className={
              selectedOrder?.status === "Delivered" &&
              "disabled complete-disabled"
            }
          >
            Confirm Order Received
          </ButtonContainer> */}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={props.onHide}>Close</Button> */}
        </Modal.Footer>
      </Modal>
      <PaymentSuccessful
        {...{ tailoringOrderSuccess, setTailoringOrderSuccess }}
      />
    </div>
  );
};

export default TailoringOrders;

const PaymentSuccessful = ({
  tailoringOrderSuccess,
  setTailoringOrderSuccess,
}) => {
  const closeModalHandler = () => setTailoringOrderSuccess(false);
  // const navigate  = useNavigate()
  return (
    <Modal
      show={tailoringOrderSuccess}
      onHide={closeModalHandler}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="payment_success order-success">
          <img alt="img" src={Successful} />
          <h2>
            <strong>Order Confirmation Successful</strong>
          </h2>
          <h5>Your order has successfully been confirmed</h5>
          <ButtonContainer
            onClick={() => {
              setTailoringOrderSuccess(false);
            }}
          >
            Done
          </ButtonContainer>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button onClick={props.onHide}>Close</Button> */}
      </Modal.Footer>
    </Modal>
  );
};
